document.documentElement.setAttribute("data-color-theme", userSettings.ColorTheme);

document.addEventListener("turbo:load", () => {
  // Hide preloader if it's stuck
  const preloader = document.querySelector(".preloader");
  if (preloader) preloader.style.display = "none";

  // Re-run your theme initializations here
  if (window.feather) feather.replace();
  if (window.Iconify) Iconify.scan();

  // Any other init code from the theme that runs on DOM ready
  // if (window.initThemeLayout) window.initThemeLayout(); // if your theme has something like that
});